(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var header = document.getElementById('SiteHeader');
  var btn = document.querySelector('.site-header__menu-btn');
  var nav = document.getElementById('mobile-nav');

  if (btn && nav) {
    btn.addEventListener('click', function () {
      var open = nav.hidden;
      nav.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-index"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var hero = document.querySelector('.idx-hero');
  var bar  = document.getElementById('IdxStickyMobile');
  if (!hero || !bar) return;
  if (!('IntersectionObserver' in window)) return;

  var obs = new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting) {
        bar.classList.remove('idx-sticky--visible');
      } else {
        bar.classList.add('idx-sticky--visible');
      }
    },
    { threshold: 0.1 }
  );
  obs.observe(hero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* Gallery */
  document.querySelectorAll('.mp').forEach(function (section) {
    var slides = section.querySelectorAll('.mp__slide');
    var thumbs = section.querySelectorAll('.mp__thumb');

    function showSlide(idx) {
      slides.forEach(function (s, i) { s.classList.toggle('mp__slide--active', i === idx); });
      thumbs.forEach(function (t, i) {
        var on = i === idx;
        t.classList.toggle('mp__thumb--active', on);
        t.setAttribute('aria-pressed', on);
      });
    }

    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { showSlide(i); }); });

    var slidesWrap = section.querySelector('.mp__slides');
    var swipeStartX = 0;
    if (slidesWrap) {
      slidesWrap.addEventListener('touchstart', function (e) { swipeStartX = e.touches[0].clientX; }, { passive: true });
      slidesWrap.addEventListener('touchend', function (e) {
        var diff = swipeStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 50) return;
        var cur = Array.from(slides).findIndex(function (s) { return s.classList.contains('mp__slide--active'); });
        var next = diff > 0 ? Math.min(cur + 1, slides.length - 1) : Math.max(cur - 1, 0);
        if (next !== cur) showSlide(next);
      }, { passive: true });
    }

    /* Quantity */
    var qtyIn = section.querySelector('.mp__qty-in');
    section.querySelectorAll('.mp__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(qtyIn.value, 10) || 1;
        qtyIn.value = Math.max(1, val + parseInt(btn.dataset.dir, 10));
      });
    });

    /* Variants */
    var variantsEl = document.getElementById('ProductVariantsJSON');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var variantIdInput = section.querySelector('#VariantId');
    var priceEl = section.querySelector('.mp__price');
    var addBtn = section.querySelector('#AddBtn');
    var selected = {};

    section.querySelectorAll('.mp__opt-btn').forEach(function (btn) {
      if (btn.getAttribute('aria-pressed') === 'true') selected[btn.dataset.optPos] = btn.dataset.optVal;
    });

    section.querySelectorAll('.mp__opt-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.dataset.optPos;
        selected[pos] = btn.dataset.optVal;
        section.querySelectorAll('.mp__opt-btn[data-opt-pos="' + pos + '"]').forEach(function (b) {
          var on = b.dataset.optVal === btn.dataset.optVal;
          b.classList.toggle('mp__opt-btn--on', on);
          b.setAttribute('aria-pressed', on);
        });
        var label = section.querySelector('[data-opt-label="' + pos + '"]');
        if (label) label.textContent = btn.dataset.optVal;
        var match = variants.find(function (v) {
          return Object.keys(selected).every(function (p) { return v['option' + p] === selected[p]; });
        });
        if (!match) return;
        variantIdInput.value = match.id;
        updatePrice(match);
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to Cart — ' + fmtPrice(match.price) : 'Sold Out';
        if (match.featured_image && match.featured_image.position) {
          showSlide(match.featured_image.position - 1);
        }
        var ctaScrollBtn = document.getElementById('CtaScrollBtn');
        if (ctaScrollBtn) ctaScrollBtn.textContent = 'Add to Cart — ' + fmtPrice(match.price);
      });
    });

    function fmtPrice(cents) { return '£' + (cents / 100).toFixed(2); }
    function updatePrice(variant) {
      if (!priceEl) return;
      var html = '';
      if (variant.compare_at_price > variant.price) {
        var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        html = '<span class="mp__price-sale">' + fmtPrice(variant.price) + '</span>'
             + '<s class="mp__price-was">' + fmtPrice(variant.compare_at_price) + '</s>'
             + '<span class="mp__price-badge">−' + pct + '%</span>';
      } else {
        html = '<span class="mp__price-reg">' + fmtPrice(variant.price) + '</span>';
      }
      priceEl.innerHTML = html;
      var sp = document.getElementById('StickyPrice');
      if (sp) sp.textContent = fmtPrice(variant.price);
    }
  });

  /* Sticky bar */
  (function () {
    var bar = document.getElementById('StickyBar');
    var mainBtn = document.getElementById('AddBtn');
    var stickyBtn = document.getElementById('StickyBtn');
    if (!bar || !mainBtn) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(mainBtn);
    if (stickyBtn) { stickyBtn.addEventListener('click', function () { mainBtn.click(); }); }
  })();

  /* Scroll reveal */
  (function () {
    var els = document.querySelectorAll('.klick-reveal-section');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* Pre-select colour from homepage swatch links (?color=NAME in URL) */
  (function () {
    var color = new URLSearchParams(window.location.search).get('color');
    if (!color) return;
    var btn = document.querySelector('.mp__opt-btn[data-opt-pos="1"][data-opt-val="' + color + '"]');
    if (btn && btn.getAttribute('aria-pressed') !== 'true') btn.click();
  })();

  /* Colour swatches in "4 Colours" section → select option + scroll to product */
  (function () {
    var swatches = document.querySelectorAll('.klick-swatch[data-color]');
    var mp = document.querySelector('.mp');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var colorName = swatch.dataset.color;
        var optBtn = document.querySelector('.mp__opt-btn[data-opt-pos="1"][data-opt-val="' + colorName + '"]');
        if (optBtn) {
          optBtn.click();
          swatches.forEach(function (s) { s.classList.remove('is-selected'); });
          swatch.classList.add('is-selected');
        }
        if (mp) mp.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  var visual = document.getElementById('SsVisual');
  var panels = document.querySelectorAll('.ss__panel');
  if (!visual || !panels.length) return;

  function setActive(idx) {
    visual.dataset.state = String(idx);
    panels.forEach(function (p, i) {
      p.classList.toggle('is-active', i === idx);
    });
  }

  setActive(0);

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        setActive(parseInt(e.target.dataset.state, 10));
      }
    });
  }, { threshold: 0.5, rootMargin: '-10% 0px -10% 0px' });

  panels.forEach(function (p) { io.observe(p); });
})();

  } catch(e) { console.error(e); }
})();
})();
